import { render, staticRenderFns } from "./ningxiaUnionPayUnionConfigure.vue?vue&type=template&id=8573f0aa&scoped=true"
import script from "./ningxiaUnionPayUnionConfigure.vue?vue&type=script&lang=js"
export * from "./ningxiaUnionPayUnionConfigure.vue?vue&type=script&lang=js"
import style0 from "./ningxiaUnionPayUnionConfigure.vue?vue&type=style&index=0&id=8573f0aa&prod&scoped=true&lang=css"
import style1 from "./ningxiaUnionPayUnionConfigure.vue?vue&type=style&index=1&id=8573f0aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8573f0aa",
  null
  
)

export default component.exports